import { render, staticRenderFns } from "./fvSidebar.vue?vue&type=template&id=1ace9a2c&lang=pug&"
import script from "./fvSidebar.vue?vue&type=script&lang=js&"
export * from "./fvSidebar.vue?vue&type=script&lang=js&"
import style0 from "./fvSidebar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/framevuerk-builder/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "fvSidebar.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/fvSidebar.vue
// module id = 98
// module chunks = 0 1